import * as React from "react";

export const useCustomerPermission = (permissionType: string) => {
  const [permitted, setPermitted] = React.useState<boolean>(false);
  const [loading, setLoading] = React.useState<boolean>(true);
  const [refreshTrigger, setRefreshTrigger] = React.useState<number>(0);

  const refresh = React.useCallback(() => {
    setRefreshTrigger((prev) => prev + 1);
  }, []);

  React.useEffect(() => {
    const fetchPermission = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `/get_customer_permissions?type=${permissionType}`
        );
        const data = await response.json();
        setPermitted(data.resource);
      } catch (error) {
        console.error("Error getting permission", error);
        setPermitted(false);
      } finally {
        setLoading(false);
      }
    };

    fetchPermission();
  }, [permissionType, refreshTrigger]);

  return { permitted, loading, refresh };
};
